import RvStorageHero from 'assets/images/psp/PSPHero/rv-hero.webp';
import indoorRvStorage from 'assets/images/psp/RvStorage/rvStorageComparison/indoor.svg';
import coveredRvStorage from 'assets/images/psp/RvStorage/rvStorageComparison/covered.svg';
import outdoorRvStorage from 'assets/images/psp/RvStorage/rvStorageComparison/outdoor.svg';
import { storageCategories } from '../utils/getPSPLinks';
import videoContentImage from 'assets/images/psp/RvStorage/RV-winterization-steps.png';
import relatedContentImage1 from 'assets/images/psp/FeaturedContentImages/vehicle2.webp';
import relatedContentImage2 from 'assets/images/psp/FeaturedContentImages/vehicle3.webp';
import relatedContentImage3 from 'assets/images/psp/FeaturedContentImages/vehicle4.webp';
import relatedContentImage4 from 'assets/images/psp/FeaturedContentImages/vehicle1.webp';

const heroContent = {
	title: 'Find Affordable RV Self Storage',
	description:
		"Protect your family's RV investment and secure years of memories to come with off-season RV storage. It's easier than ever to find a safe, well-maintained camper storage unit to protect your recreational vehicle without breaking the bank (or dipping into your vacation fund).\n\n Proper motorhome and camper storage protects your vehicle from the elements and offers superior accessibility and flexibility with your space and time. Keep your home away from home safe and out of your driveway with the simple **SelfStorage.com** find and compare tool.",
	image: RvStorageHero,
	storageType: 'RV Storage',
	CTAtext: 'Find RV Self Storage',
};

const sizeComparisonContent = {
	title: 'Size Comparison Section',
	background: 'lighterBlue',
	modules: [
		{
			type: 'sizeComparisonSection',
			props: {
				content: {
					title: 'Find the Right RV Storage Space Size For Your Needs & Budget',
				},
				storageData: [
					{
						size: '10x15',
						heading: "10' Wide x 15' Long",
						desc: [
							'The entry-level size for an RV storage space, best for small trailers and teardrop campers.',
							' Often available as an indoor RV storage space.',
						],
					},
					{
						size: '10x20',
						heading: "10' Wide x 20' Long",
						desc: [
							'Provides more space for your small pop-up campers and other compact recreational vehicles.',
							'Similar to a 10x15 storage unit, this size is often available as an indoor option.',
						],
					},
					{
						size: '10x25',
						heading: "10' Wide x 25' Long",
						desc: [
							'Class B RVs can fit into a unit of this size, which offers 250 square feet of storage space.',
							'This is among the most common RV storage unit sizes.',
						],
					},
					{
						size: '10x30',
						heading: "10' Wide x 30' Long",
						desc: [
							'More spacious than its 10x25 counterpart, this space will also work for Class B and some Class C motorhome storage.',
							'Often found as an outdoor or covered storage space.',
						],
					},
					{
						size: '10x40',
						heading: "10' Wide x 40' Long",
						desc: [
							'The largest of the common outdoor and covered RV storage options, this space is ideal for Class C RVs, many haulers, trailers, and other consumer motorhomes.',
						],
					},
				],
			},
		},
	],
};

const sizeChartContent = [
	{
		type: 'cardStrip',
		props: {
			heading: 'RV Storage Rates Comparison',
			cardData: [
				{
					title: 'Indoor RV Storage',
					content:
						'**Average Monthly Cost:** $150-400\n\n**Available Sizes:** 10x25, 10x30, 10x40, 10x40\n\n**Benefits:** Complete weather protection, climate control, enhanced security, protection from UV damage, pest control',
					imageSrc: indoorRvStorage,
					contentAlign: 'text-left',
				},
				{
					title: 'Covered RV Storage',
					content:
						'**Average Monthly Cost:** $125-200\n\n**Available Sizes:** 10x20, 10x25, 10x30, 10x40\n\n**Benefits:** Protection from rain/snow/sun, moderate UV protection, good ventilation, more affordable than indoor',
					imageSrc: coveredRvStorage,
					contentAlign: 'text-left',
				},
				{
					title: 'Outdoor RV Storage',
					content:
						'**Average Monthly Cost:** $75-150\n\n**Available Sizes:** 10x15, 10x20, 10x25, 10x30, 10x40\n\n**Benefits:** Opens up space at home, great for temporary offsite parking. Most affordable RV storage option',
					imageSrc: outdoorRvStorage,
					contentAlign: 'text-left',
				},
			],
		},
	},
];

const videoContent = {
	title: 'RV Video section',
	background: 'blueGradient',
	modules: [
		{
			type: 'video',
			props: {
				content: {
					title: 'Prepare Your Camper for Offseason Storage',
					description:
						"Before you put your beloved camper into storage for the winter, it's important to take the steps to properly prepare your vehicle for extended downtime.\n\n Know the steps necessary to winterize your RV so you don't miss a beat when traveling season comes back around. Check out our comprehensive guide to DIY RV winterization.",
					imageSrc: videoContentImage,
				},
			},
		},
	],
};

const reviewsContent = {
	headerTitle: 'RV Storage & Parking: ',
	reviews: [
		{
			title: 'SelfStorage RV storage - Quick & Easy!',
			stars: 5,
			text: "I made the reservation online and then called the listed # to confirm the spot. It showed only one space available, and I wanted to make sure it was still open. They connected me to the manager on site, who was extremely professional, courteous and efficient. She confirmed the (40') space was available, completed the payment for the first two months, and sent me all the necessary paperwork and receipt to confirm the rental.",
			customerName: 'Donald Tarney',
			date: 'Dec 5, 2024',
			link: 'https://www.trustpilot.com/users/5e3570db6167813d408d17d0',
		},
		{
			title: 'Fast, friendly, and courteous.',
			stars: 5,
			text: 'Fast, friendly, and courteous. Got setup right away super easy online, and the friendly follow up phone call got everything in order from there.',
			customerName: 'Jacob L.',
			date: 'Oct 15, 2025',
			link: 'https://www.trustpilot.com/reviews/68efad1da3e00c93a2de1a9b',
		},
		{
			title: 'Service was beyond expectations',
			stars: 5,
			text: "Everything was done over the phone and Ivana was available at all times to get me approved. I'm so grateful to hear, I would have been lost without her. The unit was perfect, clean and easy to access.",
			customerName: 'Gary',
			date: 'Oct 14, 2025',
			link: 'https://www.trustpilot.com/reviews/68ee4f1837e3c6c408c1e8f4',
		},
		{
			title: 'It was very easy to reserve',
			stars: 5,
			text: 'It was very easy to reserve. I called to reserve it and walked through the whole process. I later got a call with more details as to how to access the unit. Very happy with the whole process.',
			customerName: 'Carolyn Nutter',
			date: 'Oct 12, 2025',
			link: 'https://www.trustpilot.com/reviews/68ea8a720e866fa2916e76b8',
		},
	],
};

const faqSectionContent = {
	header: 'RV Self Storage FAQs',
	description: '',
	faqs: [
		{
			question: 'What do I need to know about how to store an RV?',
			answer: "To safely store your RV, there are a few essential steps that you need to take. The first is to thoroughly clean your motorhome and remove all food, crumbs, and perishable items to prevent pests.\n\nThe next step is to clean and wax the outside of your RV before sealing windows, exhaust pipes, and other entry points.\n\nYou will want to unplug your battery and top off any fluids.\n\nConsider tire protection by inflating your tires to the proper PSI outlined in your owner's manual, and consider using jack stands to keep your tires healthy while your camper is in storage.\n\nFor long-term RV storage, you'll also want to properly winterize your motorhome. Follow this [step-by-step guide](https://www.selfstorage.com/blog/rv-winterization-guide/) to prepare your vehicle for some downtime without breaking the bank.",
		},
		{
			question: 'How much does it cost to put an RV in storage?',
			answer: 'The average monthly cost of RV and camper storage will vary greatly depending on your location, size, and storage type. Indoor RV storage that offers full protection at a higher price point, while outdoor and covered motorhome parking spaces offer a more economical option for the budget-conscious.\n\nThe **SelfStorage.com** search and compare tool makes it easy to find and compare rates for RV storage based on location, unit size, and storage type. You can even reserve your unit online with no credit card.',
		},
		{
			question: 'How much does insurance cost for an RV?',
			answer: 'RV insurance costs vary, but tend to range from $500 to $1,500 per year based on RV type and classification.\n\n- Trailers: Average $500-600/year\n\n- Class C RVs: $800-1,000/year\n\n- Class A/B Motorhomes: $1,000-2,0,00/year\n\n- Liability Only: $125/year and up',
		},
		{
			question: 'What size RV fits in a parking space?',
			answer: "Standard parking spaces (9x18 feet) can only accommodate small RVs like compact Class B campervans under 20 feet. Most RVs require specialized storage:\n\n- **Class B Campers:** 16'-24' - may fit in some oversized parking spaces\n- **Class C:** 20'-33' - require RV parking or storage\n- **Class A:** 28'-41' - need dedicated RV storage",
		},
	],
};

const relatedContent = {
	heading: 'Learn All About RV Self Storage',
	type: 'unitCards',
	id: 'rv-storage-related-content',
	data: {
		slug: 'rv-storage-related-content',
		unitCards: [
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/rv-winterization-guide/',
				layout: false,
				plain: true,
				date: 'January 21, 2025',
				image: relatedContentImage1,
				content: 'RV & Camper Winterization: Essential Steps',
			},
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/long-term-rv-storage-tips-2/',
				layout: false,
				plain: true,
				date: 'September 9, 2025',
				image: relatedContentImage2,
				content:
					'RV Storage: Long-Term Storage Types & Tips to Prepare',
			},
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/outdoor-gear-shed-storage-unit/',
				layout: false,
				plain: true,
				date: 'October 3, 2025',
				image: relatedContentImage3,
				content: 'Sports Equipment Storage Guide',
			},
			{
				title: 'Storage Tips',
				url: 'https://www.selfstorage.com/blog/car-storage-size-guide/',
				layout: false,
				plain: true,
				date: 'March 3, 2025',
				image: relatedContentImage4,
				content: 'Choosing the Right Storage Unit for Your Vehicle',
			},
		],
	},
};

const moreWaysToStoreContent = [
	{
		type: 'links',
		props: {
			heading: {
				headingName: 'More ways to store',
			},
			type: 'unitCards',
			id: 'storage size unit cards',
			linksList: storageCategories.rv,
		},
	},
];

export const RvStorageContent = {
	type: 'RV',
	reviews: reviewsContent.reviews,
	sections: [
		{
			title: 'RV Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'rv-storage-hero',
					props: {
						content: heroContent,
						additionalProps: {
							heading: {
								size: 'large',
								color: 'white',
								weight: 'ultraBold',
							},
						},
					},
				},
			],
		},
		sizeComparisonContent,
		{
			title: 'RV Storage Size Chart',
			modules: sizeChartContent,
		},
		videoContent,
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					title: 'Reviews Section',
					slug: 'rv-storage-reviews',
					props: {
						reviewsData: reviewsContent,
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						content: faqSectionContent,
					},
				},
			],
		},
		{
			title: 'Related Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: relatedContent,
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: moreWaysToStoreContent,
		},
		{
			background: 'gray',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'RV',
					},
				},
			],
		},
	],
};
